<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header="Card Details">
            <b-row>
              <b-col sm="6">
                <b-form-group>

                  <label for="name"> <b>Ledger No: </b> {{ customercard.ledgerno }} </label>
                  <div class="small text-muted"></div>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Monthly Pay:</b> {{ customercard.monthlypay }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Customer Name:</b> {{ customercard.customername }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Opening Month:</b> {{ customercard.openingmonth }}-{{
                    customercard.openingyear
                  }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Address: </b>{{ customercard.address }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Closing Month:</b> {{ customercard.closingmonth }}-{{
                    customercard.closingyear
                  }} </label>
                </b-form-group>
              </b-col>


              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Scheme Name: </b>{{ customercard.schemename }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Bonus Months: </b> {{ customercard.schemebonusmonths }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Scheme Months:</b>{{ customercard.schememonths }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6" v-if="customercard.schemefirmbonusmonths != ''">
                <b-form-group>
                  <label for="name"> <b> {{ customercard.companyname }} Contribution Months:</b> {{
                    customercard.schemefirmbonusmonths
                  }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Card Wallet:</b> {{ cardData.card_wallet }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="name"> <b>Created Date: </b>{{ customercard.createddate }} </label>
                </b-form-group>
              </b-col>

            </b-row>


            <div class="card-body">
              <vue-good-table :columns="columns4" :rows="rows4"
                styleClass="vgt-table striped bordered table-sm condensed">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'action'">
                    <input type="checkbox" title="Select to Print" :value="props.row.id"
                      v-on:click="printfunction(props.row.id, $event)">
                    <i class="fa fa-plus" style="color: #63c2de; font-size: 20px; cursor: pointer;  " title="Make a Payment"
                      v-on:click="editEntry(props.row)"
                      v-if="cardData.status == 'Open' && props.row.payment_status == false"></i>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>


          </b-card>
        </b-col><!--/.col-->
      </b-row><!--/.row-->
    </div>

    <!-- Modal Component -->
    <b-modal title="Add Entry" v-model="myModal" @ok="payment_gate1()">
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <label for="name"> Month </label>
            <b-form-input type="text" autocomplete="off" v-model="cardData.pay_month" disabled></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group>

            <label for="name"> Pay Monthly</label>
            <b-form-input type="text" placeholder="Enter Pay Monthly" autocomplete="off" v-model="cardData.pay_monthly"
              disabled></b-form-input>
          </b-form-group>
          <b-form-group>
            <label for="name"> Recieved Date</label><br />
            <date-picker v-if="super_user == 1" editable lang="en" v-model="cardData.recieved_date"></date-picker>
            <date-picker v-else editable lang="en" v-model="cardData.recieved_date" disabled></date-picker>
          </b-form-group>
          <!-- <b-form-group>
                <label for="name"> Payment Mode </label>
                 <model-list-select :list="modelist" option-value="name" :custom-text="modeName" v-model="cardData.pay_mode" placeholder="Select Payment Mode"  @searchchange="searchmode" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                 <small  class="form-text text-muted"><strong style="color: red;">{{haserror.pay_mode}}</strong></small>
              </b-form-group> -->
        </b-col>
      </b-row>
    </b-modal>



  </div>

</template>

<script>
import Spinner from "../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
import company_mgmtVue from '../admin_pages/company_mgmt.vue';

export default {
  name: 'CardDetail',
  components: {
    "date-picker": DatePicker,
    Spinner,
  },

  data: function () {
    return {
      super_user: 3,
      smsFlag: 0,
      todate: "",
      mnth: '',
      card_id: '',
      card_entry_id: '',
      selectcompany: null,
      monthlist: [],
      rows4: [],
      modelist: [],
      queue: [],
      orderStat: '',
      customercard: {
        ledgerno: null,
        monthlypay: null,
        openingmonth: null,
        closingmonth: null,
        closingyear: null,
        companyname: null,
        regcity: null,
        company_id: null,
        closingndate: null,
        schemename: null,
        schememonths: null,
        schemebonusmonths: null,
        createddate: null,
        schemefirmbonusmonths: null,
        openingyear: null,
        customername: null,
        custmobile: null,
        custemail: null,
        address: null,
        customer_id: null
      },

      cardData: {
        pay_month: '',
        pay_monthly: '',
        recieved_by: '',
        recieved_date: new Date().toISOString().slice(0, 10),
        card_wallet: '',
        pay_mode: '',
        status: '',

      },
      cardCloseData: {
        purchase_amount: '',
        purchase_date: new Date().toISOString().slice(0, 10),
        bonus_amt: '',
        ref_bonus_amt: '',
        extra_amount: '0',
        est_shop_id: '',
        scheme_id: '',
        bill_no: '',

      },
      haserror: {
        cardWallet: '',
        pay_mode: ''
      },

      myModal: false,
      myCloseModal: false,
      columns: [
        {
          label: 'Month',
          field: 'month',
        },
        {
          label: 'Pay Monthly',
          field: 'paymonthly',
          type: 'number',
        },
        {
          label: 'Received Date',
          field: 'receiveddate',
          type: 'date',
          // dateInputFormat: 'yyyy-mm-dd',
          // dateOutputFormat: 'MMM do yy',
          dateInputFormat: "YYYY-MM-DDThh:mm:ss",
          dateOutputFormat: "Do MMM YYYY",
        },
      ],
      columns4: [
        {
          label: "Month",
          field: "pay_month",
          width: "15% !important",
          thClass: "text-left",
        },
        {
          label: "Monthly Pay",
          field: "pay_monthly",
          width: "15% !important",
          thClass: "text-left",
        },
        {
          label: "Mode of Payment",
          field: "pay_mode",
          width: "15% !important",
          thClass: "text-left",
        },
        {
          label: "Received Date",
          field: "pay_date",
          type: "date",
          dateInputFormat: "YYYY-MM-DD",
          dateOutputFormat: "DD-MM-YYYY",
          tdClass: "text-left",
          thClass: "text-left",
          width: "15% !important",
        },
        {
          label: "Received By",
          field: "recieved_by",
          width: "15% !important",
          thClass: "text-left",
        },
        {
          label: "Action",
          field: "action",
          width: "10% !important",
          thClass: "text-left",
          tdClass: "text-left",
        },

        // {
        //   label: "Return",
        //   field: "return",
        //   width: "5% !important",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
      ],
      // rows: [
      //   { id:1, month:"March", paymonthly: 5000, receiveddate: '2011-10-31', score: 0.03343 },
      //   { id:2, month:"Susan", paymonthly: 5000, receiveddate: '2011-10-30', score: 0.03343 },
      // ],
    }
  },
  async created() {
    await this.show_currentMonth();
    await this.show_carddetail();
    await this.searchmode();
    await this.show_card_entry();
    await this.checkOrderStatus();
    localStorage.removeItem("printentry");

  },
  methods: {
    printfunction: function (value, event) {
      if (event.target.checked) {
        this.queue.push(value);
      } else if (!event.target.checked) {
        // console.log(value)
        const index = this.queue.indexOf(value);
        this.queue.splice(index, 1);

      }
      localStorage.setItem("printentry", JSON.stringify(this.queue))
    },

    checkOrderStatus() {
      var _this = this
      //console.log("Order Status CHeck")
      //console.log(this.$route.query.order_id)
      //console.log(this.$route.query.order_token)
      var data = "&filter[where][order_id]=" + this.$route.query.order_id;
      if (this.$route.query.order_id == undefined || this.$route.query.order_id == '' || this.$route.query.order_id == null) {
        //console.log("no order present")
      }
      else {
        this.$http.get("/api/customermonthentries/GetOrder?params=" + data)
          .then(function (response) {
            // _this = this
            //console.log(response.data.order_status)
            // _this.rows4 =response.data
            // _this.cardEntryUpdate1();
            // console.log(_this.card_entry_id )
            if (response.data.order_status == "PAID") {
              // console.log('Payment Status PAID')
              _this.afterSuccess();
            }
          })
          .catch(function (error) {
            console.log(error)
          });
      }


    },
    payment_gateway_status() {
      var _this = this
      this.$http.get("/api/customermonthentries/getPaymentGateway?cmpid=" + _this.customercard.company_id + "&regcity=" + _this.customercard.regcity + "")
        .then(function (response) {
          console.log(response.data.status)
          if (response.data.status == 200) {
            console.log("Payment Gateway Present")
          } else if (response.data.status == 404) {
            console.log("Payment Gateway Not Present")
            _this.cardData.status = "Close"
          }
        }).catch(function (error) {
          console.log(error)
        });

    },
    afterSuccess() {
      // console.log("Card Entry Id")
      var _this = this
      //console.log(_this.card_entry_id )
      _this.card_entry_id = JSON.parse(localStorage.getItem('cardEntryId'));
      if (_this.card_entry_id == null || _this.card_entry_id == '' || _this.card_entry_id == undefined) {
        //console.log("No Payment Initiated")
      } else {
        // console.log(_this.card_entry_id);
        var data = "&filter[where][id]=" + this.card_entry_id + "&filter[where][card_id]=" + this.card_id;
        // console.log("If Payment Paid")
        //console.log(data)
        _this.Paycardentry(_this)
      }

    },
    payment_gate1() {
      var _this = this
      let orderToken = "";
      this.monthlypay = _this.customercard.monthlypay;
      // console.log("this is the order amount: "+ this.monthlypay)
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < 30; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      let body =
      {

        customer_id: _this.customercard.customer_id,
        customer_name: _this.customercard.customername,
        customer_email: _this.customercard.custemail,
        customer_phone: _this.customercard.custmobile,
        order_amount: this.monthlypay,
        cmpid: _this.customercard.company_id,
        regcity: _this.customercard.regcity,
      }
      // console.log(body)

      localStorage.setItem('oderID', body.order_id)

      if (orderToken == "") {
        this.$http.post("/api/customermonthentries/generateOrderToken", body)
          .then(function (response) {
            if (response.status === 200) {
              // console.log(response.data)
              _this.orderToken = response.data.order_token;
              // console.log("this is order token: " + _this.orderToken)
              var payment_link = response.data.payment_link;
              // console.log("this is a payment link: " + payment_link)
            }

            window.location.href = payment_link;
            // console.log(payment_link)
            localStorage.setItem('oderTkn', _this.orderToken)

            // console.log("end of payment gateway")
          });
      }
    },
    searchmode() {
      var _this = this
      var myObj = [
        {
          "id": "1",
          "name": "Cash"
        },
        {
          "id": "2",
          "name": "Cheque"
        },
        {
          "id": "3",
          "name": "UPI"
        },
        {
          "id": "4",
          "name": "Online"
        },
      ];
      _this.modelist = myObj
    },
    modeName(item) {
      return `${item.name}`
    },

    editEntry(entryid) {
      var _this = this;
      this.reset();
      this.myModal = true
      this.cardData.pay_month = entryid.pay_month
      this.card_entry_id = entryid.id
      localStorage.setItem('cardEntryId', this.card_entry_id)
      localStorage.setItem('pay_Month', this.cardData.pay_month)

      // this.cardData.monthlypay = schemeid.monthly_pay
      // this.cardData.schememonths = schemeid.scheme_months
      // this.cardData.schemebonusmonths = schemeid.scheme_bonus_months
      // this.scheme_id = schemeid.scheme_id

    },
    reset() {
      this.cardData.schemename = ''
      this.cardData.monthlypay = ''
      this.cardData.schememonths = ''
    },

    cardEntryUpdate() {
      var _this = this
      this.submit_true = 0;
      if (this.submit_true == 0) {
        this.loading = true
        var user = null;
        _this.submitcardentry(_this)

      }
    },
    submitcardentry(_this) {
      var num = /^[0-9]{1}$/;
      var dateto = new Date(this.cardData.recieved_date);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      this.loading = true;
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }
      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }
      var todate1 = year + "-" + month + "-" + day;
      let res = {
        customer_id: this.customercard.customer_id,
        ig_card_id: this.card_id,
        ledger_no: this.customercard.ledgerno,
        pay_month: this.cardData.pay_month,
        pay_monthly: this.cardData.pay_monthly,
        pay_date: todate1,
        pay_mode: this.cardData.pay_mode,
        payment_status: 'TRUE'
      }
      this.$http.post('/api/customermonthentries/update?where[id]=' + this.card_entry_id, res)
        .then(function (response) {
          if (response.status == 200) {
            _this.message = true
            _this.message = "Card Entry Successfully"
            // alert("Card Entry Successfully")
            setTimeout(function () { _this.message = ''; }, 2000);
            _this.loading = false;
            _this.show_card_entry();
            _this.show_carddetail();
            _this.myModal = false;
            // _this.getTotals();
            // console.log("Flag"+ _this.smsFlag+""+_this.customercard.custmobile)
            if (_this.smsFlag == 1) {
              _this.sendSms()
            }

            _this.reset();

          } else {
            console.log('error')
          }

        })
        .catch(function (error) {
          _this.loading = false
          console.log(error)
        });
    },
    Paycardentry(_this) {
      // let filteParam = {};
      // filteParam.page = this.serverParams1.page;
      // filteParam.perPage = this.serverParams1.perPage;
      // filteParam.sort = this.serverParams1.sort;
      // console.log("i m after payment work!!")
      var num = /^[0-9]{1}$/;
      var dateto = new Date(this.cardData.recieved_date);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      this.loading = true;
      if (num.test(month) == true) { var month = "0" + month; }
      else { var month = month; }
      if (num.test(day) == true) { var day = "0" + day; }
      else { var day = day; }
      var todate1 = year + "-" + month + "-" + day;
      var data = "&filter[where][id]=" + this.card_entry_id + "&filter[where][card_id]=" + this.card_id;
      let res =
      {
        card_entry_id: _this.card_entry_id,
        card_id: _this.card_id,
        cmpid: _this.customercard.company_id,
        regcity: _this.customercard.regcity,
        receiveddate: todate1,
        ledger_no: this.customercard.ledgerno,
        customer_id: this.customercard.customer_id,
        payment_status: 'TRUE',
        order_id: this.$route.query.order_id
      }
      console.log(res)
      localStorage.setItem('cardId', res.card_id)

      //console.log("/api/customermonthentries/updateCustCardEntry?params="+data,res)
      this.$http.post("/api/customermonthentries/updateCustCardEntry", res)
        .then(function (response) {
          if (response.status == 200) {
            // console.log(response.data)
            _this.message = true
            _this.message = "Card Entry Successfully"
            //alert("Card Entry Successfully")
            setTimeout(function () { _this.message = ''; }, 2000);
            _this.loading = false;
            _this.show_card_entry();
            _this.show_carddetail();

            alert("Payment Successfull")
            localStorage.removeItem("cardEntryId");
            _this.myModal = false;
            // _this.getTotals();
            _this.customerPayStatement()
            // console.log("Flag"+ _this.smsFlag+""+_this.customercard.custmobile)

            if (_this.smsFlag == 1) {
              _this.sendSms()
            }
            _this.reset();
          }
          else {
            console.log('error')
          }
        }).catch(function (error) {
          _this.loading = false
          console.log(error)
        });
    },
    // Maturity SMS after card Completion
    sendSms() {
      var _this = this

      let smsdatainsert = {
        mobile: _this.customercard.custmobile,
        cust_name: _this.customercard.customername
      }

      // console.log('front end hitting  + api '  + smsdatainsert)
      this.$http.post('/api/customermonthentries/maturitysmsprovider', smsdatainsert)
        .then(function (response) {
          // console.log(response)
          if (response.status == 200) {
            _this.message = true
            _this.message = "Card Payement Successfully"
            setTimeout(function () { _this.message = ''; }, 2000);
          }
        }).catch(function (error) {
          _this.loading = false
          console.log(error)
        });
    },
    update_amount() {
      var _this = this
      _this.myCloseModal = true
      var amount1 = parseFloat(_this.cardData.card_wallet) || 0
      var amount2 = parseFloat(_this.cardCloseData.extra_amount) || 0
      var amount3 = parseFloat(_this.cardCloseData.bonus_amt) || 0
      var amount4 = parseFloat(_this.cardCloseData.ref_bonus_amt) || 0
      var total_purchase = amount1 + amount2 + amount3 + amount4
      _this.cardCloseData.purchase_amount = total_purchase

    },
    show_card_entry() {
      var _this = this
      var filteParam = {};
      // console.log('3')
      //  filteParam.page = this.serverParams2.page;
      // filteParam.perPage = this.serverParams2.perPage;
      // filteParam.sort = this.serverParams2.sort;
      this.card_id = JSON.parse(localStorage.getItem('card_id'));
      // this.$http.get('/api/customermonthentries/CustomerCards')

      _this.super_user = _this.$store.getters.get_super_user;
      var cmp = 'MUMSAI1'
      var reg = 'MUM'
      var data = "&filter[where][card_id]=" + this.card_id;

      // console.log('print data')
      // console.log(data)
      this.$http
        .get(
          "/api/customermonthentries/customerperCards?params=" +
          JSON.stringify(filteParam) +
          data
        ).then(function (response) {
          // console.log('responsese')
          // console.log(response.data)
          _this.rows4 = response.data

          if (response.data[10].pay_date != null && response.data[11].pay_date == null) {

            _this.smsFlag = 1
            // console.log( _this.smsFlag)
          }
        })
        .catch(function (error) {

        });

    },

    show_carddetail() {
      console.log('2')
      var filteParam = {};
      this.card_id = JSON.parse(localStorage.getItem('card_id'));
      var _this = this;
      var data = "&filter[where][card_id]=" + this.card_id;
      //   if (this.selectcompany !== null) {
      //     data =
      //       data +
      //       "&filter[where][company_id]=" +
      //       this.selectcompany.company_id +
      //       "&filter[where][regcity]=" +
      //       this.selectcompany.regcity_code;
      //   }
      this.$http
        .get(
          "/api/customercards/srarchpercustomercard?params=" +
          JSON.stringify(filteParam) +
          data
        )
        .then(function (response, ctx) {
          // console.log('response')
          // console.log(response)
          if (response.data != undefined) {

            _this.totalRecords1 = response.data[0].totalRecords;
            response.data.shift();
            _this.customercard.ledgerno = response.data[0].ledger_no
            _this.customercard.monthlypay = response.data[0].monthly_pay
            _this.customercard.openingmonth = response.data[0].opening_month
            _this.customercard.openingyear = response.data[0].opening_year
            _this.customercard.closingmonth = response.data[0].closing_month
            _this.customercard.closingyear = response.data[0].closing_year
            _this.customercard.companyname = response.data[0].company_name
            _this.customercard.company_id = response.data[0].company_id
            _this.customercard.regcity = response.data[0].regcity_code
            var today = new Date(response.data[0].closing_date);
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            if (dd < 10) {
              dd = "0" + dd;
            }
            if (mm < 10) {
              mm = "0" + mm;
            }
            today = dd + "-" + mm + "-" + yyyy;
            // console.log("CLos:"+response.data[0].closing_date)
            _this.customercard.closingdate = today;
            _this.customercard.customername = response.data[0].cust_cmp_name
            _this.customercard.custmobile = response.data[0].cust_cmp_phone
            _this.customercard.address = response.data[0].address1
            _this.customercard.customer_id = response.data[0].customer_id
            _this.cardData.pay_monthly = response.data[0].monthly_pay
            _this.cardData.status = response.data[0].status
            _this.cardData.card_wallet = response.data[0].total_card_amount
            _this.cardCloseData.est_shop_id = response.data[0].est_shop_id
            _this.cardCloseData.scheme_id = response.data[0].scheme_id
            _this.customercard.schemename = response.data[0].scheme_name
            _this.customercard.schememonths = response.data[0].scheme_months
            _this.customercard.schemebonusmonths = response.data[0].scheme_bonus_months
            _this.customercard.schemefirmbonusmonths = response.data[0].scheme_firm_bonus_months


            var today1 = new Date(response.data[0].created_date);
            var dd = today1.getDate();
            var mm = today1.getMonth() + 1; //January is 0!
            var yyyy = today1.getFullYear();
            if (dd < 10) {
              dd = "0" + dd;
            }
            if (mm < 10) {
              mm = "0" + mm;
            }
            today1 = dd + "-" + mm + "-" + yyyy;
            _this.customercard.createddate = today1
            _this.cardCloseData.ref_bonus_amt = response.data[0].ref_wallet_amount || 0
            //_this.show_card_entry();
            //_this.show_carddetail();
            var mp = parseFloat(response.data[0].monthly_pay) * parseFloat(response.data[0].scheme_months)
            if (mp == response.data[0].total_card_amount) {
              var total_bonus = parseFloat(response.data[0].scheme_bonus_months || 0) + parseFloat(response.data[0].scheme_firm_bonus_months || 0)
              var bonus_cal = total_bonus * parseFloat(response.data[0].monthly_pay)
              _this.cardCloseData.bonus_amt = bonus_cal

            } else {
              var bonus_cal = '0'
              _this.cardCloseData.bonus_amt = bonus_cal
            }
            _this.payment_gateway_status();
          }
        });
    },
    show_currentMonth() {
      console.log('1')
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var now = new Date();
      this.mnth = months[now.getMonth()].toUpperCase()

    },

    customerPayStatement() {
      var _this = this
      // console.log("I m payment statement process")
      var num = /^[0-9]{1}$/;
      var dateto = new Date(this.cardData.recieved_date);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      this.loading = true;
      if (num.test(month) == true) { var month = "0" + month; }
      else { var month = month; }
      if (num.test(day) == true) { var day = "0" + day; }
      else { var day = day; }
      var todate1 = year + "-" + month + "-" + day;
      let res =
      {
        card_id: _this.card_id,
        cmpid: _this.customercard.company_id,
        regcity: _this.customercard.regcity,
        receiveddate: todate1,
        customer_id: this.customercard.customer_id,
        customer_phone: _this.customercard.custmobile,
        order_id: this.$route.query.order_id,
        pay_month: localStorage.getItem('pay_Month'),
        pay_monthly: this.cardData.pay_monthly,
        ledger_no: this.customercard.ledgerno,
      }
      // console.log(res)

      this.$http.post("/api/customerpaystatements/InsertPayDetails", res)
        .then(function (response) {
          //console.log(response.data)
          //console.log("this is payment phone no: " +response.data[0].cust_cmp_phone)

        });

    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/goldcustomers/CustomerCardMonthlyDetailsView.vue